import LoadingSpinner from '../_custom/LoadingSpinner/LoadingSpinner';
import styles from './McaRefreshLoader.module.scss';
import { DATA_FETCH_STATUS } from '../../store/dashboard/constants';

export const MCA_REFRESH_MESSAGE = 'Fetching latest data from MCA (takes upto 24 hours)';

export interface McaDocData {
    isFetching?: boolean;
    reportStatus?: string;
    updatedAt?: string;
}

const McaRefreshLoader = ({ mcaDocData }: { mcaDocData?: McaDocData | null }) => {
    const isFetching = mcaDocData?.isFetching === true && mcaDocData?.reportStatus === DATA_FETCH_STATUS.PROCESSING;
    if (!isFetching) return null;

    return (
        <span className={styles.McaRefreshLoader}>
            <LoadingSpinner color="var(--primary-text-colour)" height="0.9375rem" />
            <span>{MCA_REFRESH_MESSAGE}</span>
        </span>
    );
};

export default McaRefreshLoader;
